module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a61733a2c9f1307f68ff37d651c2031d.png";